import { _ as _defineProperty, a as _inherits, b as _createClass, c as _objectWithoutProperties, d as _objectSpread2, e as _classCallCheck, f as _callSuper } from '../_helpers/_rollupPluginBabelHelpers.js';
import { PureComponent } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import joinDataTestAttributes from '../global/data-tests.js';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import 'core-js/modules/es.array.concat.js';
import 'core-js/modules/es.array.reduce.js';
import 'core-js/modules/es.object.entries.js';
import 'core-js/modules/es.object.to-string.js';

var modules_e49a3529 = {"dark":"dark_rui_f090","light":"light_rui_2ac4","loader":"loader_rui_092a","spin":"spin_rui_092a","pulse":"pulse_rui_092a","children":"children_rui_092a"};

var _excluded = ["className", "data-test", "children"];
var LoaderInline = /*#__PURE__*/function (_PureComponent) {
  function LoaderInline() {
    _classCallCheck(this, LoaderInline);
    return _callSuper(this, LoaderInline, arguments);
  }
  _inherits(LoaderInline, _PureComponent);
  return _createClass(LoaderInline, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        className = _this$props.className,
        dataTest = _this$props['data-test'],
        children = _this$props.children,
        restProps = _objectWithoutProperties(_this$props, _excluded);
      var classes = classNames(modules_e49a3529.loader, className);
      var loader = /*#__PURE__*/jsx("div", _objectSpread2(_objectSpread2({}, restProps), {}, {
        "data-test": joinDataTestAttributes('ring-loader-inline', dataTest),
        className: classes
      }));
      return children ? /*#__PURE__*/jsxs(Fragment, {
        children: [loader, /*#__PURE__*/jsx("span", {
          className: modules_e49a3529.children,
          children: children
        })]
      }) : loader;
    }
  }]);
}(PureComponent);
_defineProperty(LoaderInline, "propTypes", {
  className: PropTypes.string,
  'data-test': PropTypes.string,
  children: PropTypes.node
});

export { LoaderInline as default };
